<app-spinner></app-spinner>
<app-header></app-header>
<router-outlet></router-outlet>